import { Table } from 'antd'
import type { TableProps } from 'antd'

export type LeapDataTableProps<T extends object> = TableProps<T>

/** Standard data-table shell: leap skin + horizontal scroll. */
export function LeapDataTable<T extends object>({
  className,
  scroll,
  size = 'small',
  ...rest
}: LeapDataTableProps<T>) {
  return (
    <div className="leap-table-scroll">
      <Table<T>
        className={['leap-antd-data-table', className].filter(Boolean).join(' ')}
        size={size}
        scroll={{ x: 'max-content', ...scroll }}
        {...rest}
      />
    </div>
  )
}

export default LeapDataTable
